module.exports = __webpack_public_path__ + "static/savings-hero-tiny-4a279a8909f61afc081f54f1981b3f28.jpg";